import { Component, OnInit } from '@angular/core';
import { Location, } from '@angular/common';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
import { ConfigParamsService } from '../../services/configParameters/config-params.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  protected isLoading = false;
  public error_message = '';
  constructor(private loginService: LoginService, private location: Location, private router: Router, private configParamsService: ConfigParamsService, private translateService: TranslateService) {
  }

  ngOnInit() {
    if (this.loginService.checkLogin() && this.configParamsService.isPrivateApp()) {
      this.router.navigate(['/privat/visor']);
    }
  }

  public validateForm() {
    if (this.username && this.username.length > 0 && this.password && this.password.length > 0) {
      return true;
    }
    this.error_message = this.translateService.instant("error_usuari_pwd");
    return false;
  };

  public doLogin() {
    this.isLoading = true;
    if (this.validateForm()) {
      this.loginService.doLogin(this.username, this.password).then(data => {
        if (this.loginService.checkLogin() && this.configParamsService.isPrivateApp()) {
          this.router.navigate(['/privat/visor']);
        }
        else {
          this.error_message = this.translateService.instant("error_usuari_pwd");
        }
        this.isLoading = false;
      }).catch(error => {
        this.error_message = error;
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  }



}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/login/login.component.ts